import type { SearchPageResults } from '@atlassian/search-client';

export const getResultIdsAsString = (results: SearchPageResults | undefined): string => {
	const resultIds = results?.edges?.map((edge) => edge.node.id);
	return resultIds ? resultIds.join(',') : '';
};
